import { createSelector } from '@reduxjs/toolkit';
import { rootSelector } from '../root/root.selectors';

export const overlaysSelector = createSelector(rootSelector, state => state.overlays);

export const overlaysDataSelector = createSelector(
  overlaysSelector,
  overlays => overlays?.data || [],
);

export const overlaysIdsAndOrderSelector = createSelector(overlaysDataSelector, overlays =>
  overlays.map(({ id, order }) => ({ id, order })),
);

export const overlaySelector = createSelector(
  [overlaysDataSelector, (_, overlayId: number): number => overlayId],
  (overlays, overlayId) => overlays.find(overlay => overlay.id === overlayId),
);

export const loadingAddOverlay = createSelector(
  overlaysSelector,
  state => state.addOverlay.loading,
);

const userOverlaysSelector = createSelector(overlaysSelector, overlays => overlays.userOverlays);

export const loadingUserOverlaysSelector = createSelector(
  userOverlaysSelector,
  state => state.loading,
);

export const userOverlaysDataSelector = createSelector(
  userOverlaysSelector,
  overlays => overlays.data || [],
);

export const userOverlaysIdsAndOrderSelector = createSelector(
  userOverlaysDataSelector,
  userOverlays => userOverlays?.map(({ id, order }) => ({ id, order })) || [],
);

export const userOverlaySelector = createSelector(
  [userOverlaysDataSelector, (_, userOverlayId: number): number => userOverlayId],
  (userOverlays, userOverlayId) =>
    userOverlays?.find(userOverlay => userOverlay.id === userOverlayId),
);

export const overlaysIdsAndNotMatchingAlphaSelector = createSelector(
  overlaysDataSelector,
  userOverlaysDataSelector,
  (overlays, userOverlays) => {
    const userOverlaysIdsAndNotMatchingAlpha = userOverlays.map(({ id, notMatchingAlpha }) => ({
      id,
      notMatchingAlpha,
    }));
    const overlaysIdsAndNotMatchingAlpha = overlays.map(({ id, notMatchingAlpha }) => ({
      id,
      notMatchingAlpha,
    }));
    return [...userOverlaysIdsAndNotMatchingAlpha, ...overlaysIdsAndNotMatchingAlpha];
  },
);

// Project overlays selectors
const projectOverlaysSelector = createSelector(
  overlaysSelector,
  overlays => overlays.projectOverlays,
);

export const projectOverlaysLoadingSelector = createSelector(
  projectOverlaysSelector,
  state => state.loading,
);

export const projectOverlaysDataSelector = createSelector(
  projectOverlaysSelector,
  overlays => overlays.data || [],
);

export const projectOverlaysErrorSelector = createSelector(
  projectOverlaysSelector,
  state => state.error,
);

export const updateSingleOverlayLoadingSelector = createSelector(
  overlaysSelector,
  state => state.updateSingleOverlay.loading,
);

// Overlay types selectors
const overlayTypesSelector = createSelector(overlaysSelector, overlays => overlays.overlayTypes);

export const overlayTypesDataSelector = createSelector(
  overlayTypesSelector,
  overlayTypes => overlayTypes.data || [],
);

export const overlayTypesLoadingSelector = createSelector(
  overlayTypesSelector,
  state => state.loading,
);
